export default {"src":"/_next/static/image/public/images/aster_one.fc0b83cf9ebfb3bfdfb838c5cee9bdb6.svg","height":36,"width":65};